import * as React from "react";
import { renderLiveStreamingIcon } from "./renderLiveStreamingIcon";
import { renderStatisticsIcon } from "./renderStatisticsIcon";
import { renderFastMarketIcon } from "./renderFastMarketIcon";
import { renderPulseBetIcon } from "./renderPulseBetIcon";
import { getDictPhrase } from "../../../../../helpers";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";
export var renderEventIcons = function (event, dict, isDesktop, handlers) {
    return React.createElement(React.Fragment, null,
        renderFirstAvailableIcon(event, dict, isDesktop, handlers),
        renderLiveStreamingIcon(event.livestreamIcon.active, getDictPhrase(dict, event.livestreamIcon.tooltip), true, handlers.liveStream));
};
var renderFirstAvailableIcon = function (event, dict, isDesktop, handlers) {
    if (isDesktop && event.statisticsIcon.active) {
        return renderStatisticsIcon(event.statisticsIcon.active, getDictPhrase(dict, event.statisticsIcon.tooltip), handlers.statistics);
    }
    if (!isDesktop && event.pulsebetIcon.active) {
        return renderPulseBetIcon(event.pulsebetIcon.active, getDictPhrase(dict, event.pulsebetIcon.tooltip));
    }
    if (event.isLive) {
        return renderFastMarketIcon(event.fastmarketIcon.active, getDictPhrase(dict, event.fastmarketIcon.tooltip));
    }
    return createEmptyTooltipIcon();
};
//# sourceMappingURL=renderEventIcons.js.map